export default __webpack_public_path__ + "static/media/1910.6e9a1b5c.png";